<template>
	<div class="dlogD">
		<transition name="fade" mode="out-in" :duration="500">
			<div class="loginD" v-if="pageType==1" key="a">
				<div class="dlogD_tit">修改密码</div>
				<div class="dlog_body">
					<div class="unameApasD">
						<div class="unameInp">
							<input v-model="old_password" type="password" placeholder="输入旧密码" name="" id="" value="" />
						</div>
						<div class="unameInp">
							<input v-model="new_password" type="password" placeholder="输入新密码" name="" id="" value="" />
						</div>
						<div class="unameInp">
							<input v-model="re_password" type="password" placeholder="确认新密码" name="" id="" value="" />
						</div>
						<div class="loginBtn" @click="sure_modufy_api">确 认 修 改</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pageType: 1,
				old_password:'',
				new_password:'',
				re_password:'',
			}
		},
		methods:{
			sure_modufy_api(){
				let _this = this;
				let params = {
					old_password: _this.old_password,
					new_password: _this.new_password,
					re_password: _this.re_password
				};
				_this.postApi('/api/member/updatePas', params)
					.then((res) => {
						//console.log(res)
						if(res.status == '00') {
							_this.$message.success('修改成功!请重新登录');
							localStorage.removeItem('ind_user');
							localStorage.removeItem('ind_access_token');
							setTimeout(function(){
								_this.$emit('parentMethod','pas_modify');
							},2000);
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
		}
	}
</script>

<style scoped>
	.dlogD {}
	
	.loginD {
		background-color: #fff;
		border-radius: 10px;
		padding-top: 15px;
	}
	
	.dlogD_tit {
		text-align: center;
		font-size: 16px;
		height: 30px;
		line-height: 30px;
	}
	
	.dlog_body {
		padding: 30px 10px 20px 10px;
		margin: auto;
		background-color: rgba(255, 255, 255, 0);
	}
	
	.unameApasD {
		width: 80%;
		min-height: 10px;
		margin: auto;
	}
	
	.unameInp {
		text-align: center;
		display: block;
		margin: auto;
		margin-bottom: 20px;
		margin-top: 5px;
	}
	
	.unameInp input {
		line-height: 35px;
		width: 250px;
		border: 1px solid #ccc;
		padding-left: 10px;
		box-sizing: border-box;
	}
	
	.getPhoneCodeBtn {
		background-color: red;
		position: absolute;
		top: 0;
		right: 0;
		line-height: 39px;
		color: #fff;
		font-size: 12px;
		cursor: pointer;
		padding: 0 5px;
	}
	
	.getPhoneCodeBtn.sendCla {
		background-color: #ccc;
		opacity: 0.8;
	}
	
	.loginBtn {
		width: 250px;
		text-align: center;
		background-color: red;
		margin: auto;
		line-height: 35px;
		color: #fff;
		cursor: pointer;
	}
	
	.noUsername {
		width: 250px;
		text-align: right;
		padding: 0;
		margin: auto;
		margin-top: 15px;
	}
	
	.noUsername span {
		color: red;
		cursor: pointer;
	}
	
	.dlog_footer {
		text-align: right;
		padding: 10px 10px;
	}
	
	.dlog_footer button {
		margin-left: 20px;
	}
	
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s;
	}
	
	.fade-enter,
	.fade-leave-to
	/* .fade-leave-active below version 2.1.8 */
	
	{
		opacity: 0;
	}
</style>